module.exports = __webpack_public_path__ + "img/red.315485a2.svg";